var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
	'user-can-interact-hammer': _vm.userCanInteractHammer,
	'is-down': _vm.isDown
	},attrs:{"id":"otoshi"}},[_c('div',{ref:"container",attrs:{"id":"container"}})])}
var staticRenderFns = []

export { render, staticRenderFns }